/* istanbul ignore file */

import { useEffect, useState } from 'react';
import { getProductIdFromProductCode } from '@noths/polaris-client-utils';

import {
  getProductsFromRecommendationsService,
  RecommendationsServiceProductData,
} from '../../services/recommendations';
import {
  RichRelevanceProduct,
  RRDecoratedRecommendationsServiceProductData,
} from '../../types/RichRelevance';

const decorateProductsWithRRData = (
  products: RecommendationsServiceProductData[],
  placementItems: RichRelevanceProduct[],
): RRDecoratedRecommendationsServiceProductData[] =>
  products.map((product) => {
    const placementItem = placementItems.find(
      ({ id }) => getProductIdFromProductCode(product.code) === Number(id),
    );

    return {
      ...product,
      linkURL: placementItem?.linkURL ?? '',
    };
  });

export const useRichRelevanceData = (items: RichRelevanceProduct[]) => {
  const [products, setProducts] = useState([] as RecommendationsServiceProductData[]);

  useEffect(() => {
    const getRichRelevanceData = async () => {
      if (items && items.length > 0) {
        try {
          const products: RecommendationsServiceProductData[] =
            (await getProductsFromRecommendationsService(items)) ||
            ([] as RecommendationsServiceProductData[]);

          setProducts(products);
        } catch (error) {
          console.error(error);
        }
      }
    };

    getRichRelevanceData();
  }, [items]);

  return decorateProductsWithRRData(products, items);
};
